import { BatchUpdateProvider } from '../../context/VoucherBatchUpdateProvider';
import { useVoucher } from '../../context/VoucherProdiver';

import ChangeExpiration from '../VoucherActions/ChangeExpiration';
import DisableButton from '../VoucherActions/DisableButton';
import EnableButton from '../VoucherActions/EnableButton';

import styles from './voucher-detail-actions.module.scss';

const VoucherDetailActions = () => {
  const { data, refetch } = useVoucher();

  const isActive = data.status === 'active';
  const isDisabled = data.status === 'cancel';

  return (
    // Remount on voucher change so the single-voucher selection re-seeds after an update
    <BatchUpdateProvider
      key={`${data.id}-${data.status}-${data.validityInterval?.validUntil}`}
      refetch={refetch}
      initialVouchers={[data]}
    >
      <div className={styles.actions}>
        <ChangeExpiration />
        <DisableButton disabled={isDisabled} />
        <EnableButton disabled={isActive} />
      </div>
    </BatchUpdateProvider>
  );
};

export default VoucherDetailActions;
